import dayjs from 'dayjs';

export const getIntervalFromDateRange = (
  startDate: string,
  endDate: string,
): 'hourly' | 'daily' | 'weekly' | 'monthly' => {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  const diffInDays = end.diff(start, 'day');

  if (diffInDays === 0) {
    return 'hourly';
  } else if (diffInDays < 7) {
    return 'daily';
  } else if (diffInDays < 30) {
    return 'weekly';
  } else {
    return 'monthly';
  }
};

export const getRandomColor = () => `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`;
